import moment from "moment";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CompanyFullName } from "../../../Defaults";
import { background, primary, white } from "../../../styles/colors";
import { StyledButton } from "../../../styles/StyledComponents";
import { useState } from "react";
import { fetchRecursivePaginatedData } from "../../../Regex";
import { Typography } from "@material-ui/core";

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

const billColumns = (type) =>
  type == "ADMIN"
    ? [
        { label: "PO NO", key: "purchase_order_number", calculation: false },
        { label: "MILLER NAME", key: "miller", calculation: false },
        { label: "TRUCK NO", key: "truck_number", calculation: false },
        { label: "MILER BILL NO", key: "bill_number", calculation: false },
        { label: "BILL DATE", key: "bill_date", calculation: false },
        { label: "FINAL WEIGHT", key: "final_weight",},
        {
          label: "BROKERAGE AMOUNT FOR BRIPL (₹)",
          key: "brokerage_amount_for_bri",
          calculation: "sum",
          decimals: 2,
        },
        {
          label: "TOTAL PAID BY BRI (₹)",
          key: "total_paid_by_bri",
          calculation: "sum",
          decimals: 2,
        },
        {
          label: "BALANCE BY BRI (₹)",
          key: "bri_balance",
          calculation: "sum",
          decimals: 2,
        },
        {
          label: "BROKERAGE AMOUNT FOR MILLER (₹)",
          key: "brokerage_amount_for_miller",
          calculation: "sum",
          decimals: 2,
        },
        {
          label: "TOTAL PAID BY MILLER (₹)",
          key: "total_paid_by_miller",
          calculation: "sum",
          decimals: 2,
        },
        {
          label: "BALANCE BY MILLER (₹)",
          key: "miller_balance",
          calculation: "sum",
          decimals: 2,
        },
      ]
    : [
        { label: "PO NO", key: "purchase_order_number", calculation: false },
        { label: "MILLER NAME", key: "miller", calculation: false },
        { label: "TRUCK NO", key: "truck_number", calculation: false },
        { label: "MILLER BILL NO", key: "bill_number", calculation: false },
        { label: "BILL DATE", key: "bill_date", calculation: false },
        { label: "FINAL WEIGHT", key: "final_weight",},
        {
          label: "BROKERAGE AMOUNT FOR BRIPL (₹)",
          key: "brokerage_amount_for_bri",
          calculation: "sum",
          decimals: 2,
        },
        {
          label: "TOTAL PAID BY BRI (₹)",
          key: "total_paid_by_bri",
          calculation: "sum",
          decimals: 2,
        },
        {
          label: "BALANCE BY BRI (₹)",
          key: "bri_balance",
          calculation: "sum",
          decimals: 2,
        },
        {
          label: "BROKERAGE AMOUNT FOR MILLER (₹)",
          key: "brokerage_amount_for_miller",
          calculation: "sum",
          decimals: 2,
        },
        {
          label: "TOTAL PAID BY MILLER (₹)",
          key: "total_paid_by_miller",
          calculation: "sum",
          decimals: 2,
        },
        {
          label: "BALANCE BY MILLER (₹)",
          key: "miller_balance",
          calculation: "sum",
          decimals: 2,
        },
      ];

function BillPDF(name, dataList, type) {
  console.log("BillPDF", name, dataList);

  const headers = billColumns(type).map((c) => c.label);

  const body = [
    // Header row
    headers.map((h) => ({
      text: h,
      bold: true,
      border: [true, true, true, true],
      fontSize: 8,
      alignment: "center",
    })),

    // Data rows
    ...dataList.map((row, i) =>
      headers.map((h) => ({
        text: String(row?.[h] ?? ""),
        fontSize: 8,
        border: [true, true, true, true],
        bold: i == dataList.length - 1,
        alignment: "center",
      }))
    ),
  ];

  const documentDefinition = {
    pageMargins: [5, 60, 5, 50],
    pageOrientation: "landscape",
    header: {
      stack: [
        {
          margin: [10, 15, 0, 0],
          columns: [
            {
              text: CompanyFullName.toUpperCase(),
              bold: true,
              fontSize: 16,
              alignment: "center",
              margin: [0, 0, 0, 0],
            },
          ],
        },
      ],
    },

    footer: function (currentPage, pageCount) {
      return {
        columns: [
          {
            width: "*",
            margin: [0, 0, 0, 0],
            stack: [
              {
                margin: [5, 0, 5, 0],
                table: {
                  widths: [250, "*", 210],
                  body: [
                    [
                      {
                        text:
                          "Page " + currentPage.toString() + "/" + pageCount,
                        alignment: "right",
                        colSpan: 3,
                        fontSize: 7,
                        border: [false, false, false, false],
                      },
                      {},
                      {},
                    ],
                    [
                      {
                        text: "Registered Off : : Balaji Rice Industries PVT Ltd. NEAR BUS STAND, MAIN ROAD, KHARORA, RAIPUR - 493225, CHATTISGARH (INDIA)",
                        alignment: "left",
                        colSpan: 3,
                        fontSize: 9,
                        bold: true,
                        border: [false, true, false, false],
                        margin: [-3, 0, -15, 0],
                      },
                      {},
                      {},
                    ],
                    [
                      {
                        text: "Fax: +91 771 4032240, Email : bri-team@smilebots.com Web:",
                        alignment: "left",
                        fontSize: 9,
                        border: [false, false, false, true],
                        margin: [-3, 0, 0, 0],
                      },
                      {
                        text: "www.balajirice.com",
                        alignment: "center",
                        color: "#F19A30",
                        fontSize: 9.8,
                        bold: true,
                        border: [false, false, false, true],
                      },
                      {
                        text: "This is computer generated",
                        alignment: "right",
                        fontSize: 9,
                        border: [false, false, false, true],
                        margin: [0, 0, -2, 0],
                      },
                    ],
                  ],
                },
              },
            ],
          },
        ],
      };
    },

    content: [
      {
        // Header table with broker and section title
        table: {
          widths: ["*"],
          body: [
            [
              {
                text: `${name} Reports (Broker)`,
                bold: true,
                fillColor: "#F19A30",
                fontSize: 12,
                alignment: "center",
                margin: [0, 0, 0, 5],
              },
            ],
            [
              {
                text: `Dispatch Details`,
                bold: true,
                fontSize: 11,
                alignment: "center",
                margin: [0, 5, 0, 5],
              },
            ],
          ],
        },
        margin: [0, 0, 0, 0],
      },
      {
        margin: [0, 0, 0, 0],
        table: {
          headerRows: 1,
          widths:Array(headers.length).fill("auto"),
          // [

          // 65, 45, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 30, 28, 30,
          // ],
          body: body,
        },
      },
    ],

    styles: {
      basicLeft: {
        color: "#000",
        fontSize: 9,
        alignment: "left",
      },
      basicRight: {
        color: "#000",
        fontSize: 9,
        alignment: "right",
      },
      basicCenter: {
        color: "#000",
        fontSize: 9,
        alignment: "center",
      },
      basicLeftBold: {
        color: "#000",
        bold: true,
        fontSize: 9.5,
        alignment: "left",
      },
      basicCenterBold: {
        color: "#000",
        bold: true,
        fontSize: 9.5,
        alignment: "center",
      },
    },
  };

  pdfMake.createPdf(documentDefinition).open();
}

export default function BillPDFButton(props) {
  const [pdfData, setPdfData] = useState(null);
  const [clicked, setClicked] = useState(false);
  const [fetchReportProgress, setFetchReportProgress] = useState(0);

  const handleCountStateUpdate = (data) => {
    setFetchReportProgress(data);
  };

  const fetcBillPDF = () => {
    setClicked(true);
    fetchRecursivePaginatedData(
      "get",
      "arrival/broker-accounts/download",
      {
        broker_id: props.brokerId,
        // brokerage_of: props.type,
        payment_status: props.paymentStatus,
      },
      null,
      handleCountStateUpdate
    ).then(({ responseDataList }) => {
      if (responseDataList.length > 0) {
        let cleanedData = [];
        console.log(responseDataList);

        let formattedBills = [];
        let column = billColumns(props.type);
        formattedBills = responseDataList.map((item) => {
          let row = {};

          column.forEach((col) => {
            let value = item[col.key];

            // format bill date
            if (col.key === "dispatch_date") {
              value = value ? moment(value).format("ddd, MMM Do YYYY") : "";
            }
            if (col.key === "final_weight") {
              value = value
                ? String(Number(value || 0).toFixed(3)) + " " + item?.po_unit
                : "";
            }

            row[col.label] = col.decimals
              ? Number(value || 0).toFixed(col.decimals)
              : value || "";
          });
          return row;
        });

        const totalRow = column.reduce((acc, col) => {
          if (col.calculation === "sum") {
            const total = formattedBills?.reduce(
              (sum, item) => sum + (Number(item[col.label]) || 0),
              0
            );
            acc[col.label] = Number(total).toFixed(col.decimals || 0);
          } else if (col.label === "PO NO") {
            acc[col.label] = "Total"; // place label here
          } else {
            acc[col.label] = "";
          }
          return acc;
        }, {});

        formattedBills.push(totalRow);

        setClicked(false);
        setPdfData(formattedBills);
        BillPDF(props.brokerName, formattedBills, props.type);
      }
    });
  };

  return (
    <StyledButton
      name={
        clicked ? (
          <Typography
            style={{
              fontFamily: "Poppins",
              // color: "#4B87C5",
              color: primary,
              fontSize: "0.9rem",
            }}
            variant="body1"
            component="div"
            // color="text.secondary"
          >
            {`${Math.round(
              fetchReportProgress === undefined ? 0 : fetchReportProgress
            )}%`}
          </Typography>
        ) : (
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: "0.9rem",
              textTransform: "uppercase",
            }}
          >
            .PDF
          </Typography>
        )
      }
      background={white}
      padding={"2px 6px"}
      fontSize={"0.8rem"}
      border={"1px solid rgb(241, 154, 48)"}
      boxShadow={"none"}
      disabled={props.tableList?.length <= 0 || clicked}
      onClick={() => {
        console.log("PDF", props.tableList);
        fetcBillPDF();
        // this.generateBillPDF()
        // BillPDF(tableList, generatePdfList(tableList));
      }}
    />
  );
}
